import React from 'react';
import Header from '../../components/ui/Header';
import Footer from '../../components/ui/Footer';
import Breadcrumbs from '../../components/ui/Breadcrumbs';
import { useGetSystemSettingsQuery } from '../../features/api/apiSlice'; // Import the API hook
import SEO from '../../components/seo'; // Import the SEO component

const PrivacyPolicy = () => {
  const { data: systemSettings, isLoading, isError } = useGetSystemSettingsQuery();

  if (isLoading) {
    return (
      <div className="min-h-screen bg-gray-100 flex items-center justify-center">
        <p className="text-gray-700">Loading privacy policy...</p>
      </div>
    );
  }

  if (isError || !systemSettings || !systemSettings.privacy_policy) {
    return (
      <div className="min-h-screen bg-gray-100 flex items-center justify-center">
        <p className="text-red-600">Error loading privacy policy or content not found.</p>
      </div>
    );
  }

  const privacyPolicyContent = systemSettings.privacy_policy;
  const canonicalUrl = window.location.origin + '/privacy';

  return (
    <div className="min-h-screen flex flex-col bg-gray-50">
      <SEO
        title="Privacy Policy"
        description="Read HireBroker's privacy policy to understand how we collect, use, and protect your personal information in Uganda and Africa."
        keywords="privacy policy, data protection, personal information, hirebroker privacy, uganda privacy laws, africa data privacy"
        canonicalUrl={canonicalUrl}
      />
      <Header />
      <main className="flex-grow container mx-auto px-4 sm:px-6 lg:px-8 py-8 md:py-12">
        <Breadcrumbs />
        <article className="bg-white shadow-lg rounded-lg p-6 md:p-8 mt-8">
          <header className="text-center mb-8">
            <h1 className="text-4xl md:text-5xl font-extrabold text-gray-900 mb-4">Privacy Policy</h1>
            {/* The systemSettings API response does not contain a 'last_updated' field. */}
          </header>

          <section className="prose prose-lg max-w-none text-gray-700 leading-relaxed">
            <div dangerouslySetInnerHTML={{ __html: privacyPolicyContent }} />
          </section>
        </article>
      </main>
      <Footer />
    </div>
  );
};

export default PrivacyPolicy;
